import layoutPolyfill from '../polyfill/layout';

export const getTitleDescriptionId = childComponent => {
    const childType = layoutPolyfill.getType(childComponent);
    const childProps = layoutPolyfill.getProps(childComponent);
    const layoutProps =
        // If the child component is a Loading component, we will access the props of the direct child
        childType === 'Loading'
            ? childProps?.children?.props
            : // Otherwise, we can access the props of the given child component directly.
              childProps || {};

    return {
        title: childProps?.title || layoutProps?.title || '',
        description: childProps?.description || layoutProps?.description,
        id: childProps?.id || layoutProps?.id,
    };
};
